import { ProductContentVideoActionsTypes } from '../../../enums/ActionEnums';
export const productContentVideosAction = {
    getProductContentVideos: (payload) => ({
        type: ProductContentVideoActionsTypes.GET_PRODUCT_CONTENT_VIDEOS,
        payload,
    }),
};
